import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <ContactUsForm />
      <ContactDetails
        cards={[
          {
            title: "Jaipur, India",
            description: (
              <>
                <Address>
                  <AddressLine>D-38, Dev Nagar</AddressLine>
                  <AddressLine>Tonk Road, 302018</AddressLine>
                </Address>
                <Email>hello@codejocks.in</Email>
                <Phone>+91 7877735138</Phone>
              </>
            )
          },
          {
            title: "Everywhere, Earth",
            description: (
              <>
                <Address>
                  <AddressLine>Remotely Reachable</AddressLine>
                  <AddressLine>Around the Globe</AddressLine>
                </Address>
                <Email>hello@codejocks.in</Email>
                <Phone>+91 7877735138</Phone>
              </>
            )
          }
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
